export default __webpack_public_path__ + "static/media/ic_container_block.8877c2ff.svg";